export enum FilterKeys {
  Distance = 'distance',
  GoodDeals = 'good-deals',
  PriceRange = 'price-range',
  Diet = 'diet',
  PaymentMethods = 'payment-methods',
  Categories = 'categories',
}
